import { useEffect, useState } from "react";

/**
 * Debounces a value. Returns the latest value after `delay` ms of inactivity.
 *
 * Use this for reactive values (e.g. search input text).
 * For debouncing function calls, use `useDebouncedCallback` instead.
 */
export function useDebouncedValue<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timeout = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(timeout);
  }, [value, delay]);

  return debouncedValue;
}
